import axios from './axios';

export const workspace_custom_domain_services = {
	getWorkspaceDomain,
	getUserWorkspaceDomains,
	createWorkspaceDomain,
	verifyWorkspaceDomain,
	deleteWorkspaceDomain,
	lookupWorkspaceDomain,
};

function getWorkspaceDomain(workspaceId: string) {
	return new Promise(async (resolve, reject) => {
		try {
			const config = {
				method: 'get' as const,
				url: `/workspace-custom-domain/workspace/${workspaceId}`,
			};
			const resp = await axios(config);
			const response = resp.data;
			resolve(response);
		} catch (error) {
			reject(error);
		}
	});
}

function getUserWorkspaceDomains(userId: string) {
	return new Promise(async (resolve, reject) => {
		try {
			const config = {
				method: 'get' as const,
				url: `/workspace-custom-domain/user/${userId}`,
			};
			const resp = await axios(config);
			const response = resp.data;
			resolve(response);
		} catch (error) {
			reject(error);
		}
	});
}

function createWorkspaceDomain(workspaceId: string, userId: string, domain: string) {
	return new Promise(async (resolve, reject) => {
		try {
			const config = {
				method: 'post' as const,
				url: '/workspace-custom-domain',
				data: { workspaceId, userId, domain },
			};
			const resp = await axios(config);
			const response = resp.data;
			resolve(response);
		} catch (error) {
			reject(error);
		}
	});
}

function verifyWorkspaceDomain(domainId: string) {
	return new Promise(async (resolve, reject) => {
		try {
			const config = {
				method: 'post' as const,
				url: `/workspace-custom-domain/verify/${domainId}`,
			};
			const resp = await axios(config);
			const response = resp.data;
			resolve(response);
		} catch (error) {
			reject(error);
		}
	});
}

function deleteWorkspaceDomain(domainId: string) {
	return new Promise(async (resolve, reject) => {
		try {
			const config = {
				method: 'delete' as const,
				url: `/workspace-custom-domain/${domainId}`,
			};
			const resp = await axios(config);
			const response = resp.data;
			resolve(response);
		} catch (error) {
			reject(error);
		}
	});
}

function lookupWorkspaceDomain(hostname: string) {
	return new Promise(async (resolve, reject) => {
		try {
			const config = {
				method: 'get' as const,
				url: `/workspace-custom-domain/lookup?domain=${hostname}`,
			};
			const resp = await axios(config);
			const response = resp.data;
			resolve(response);
		} catch (error) {
			reject(error);
		}
	});
}
